/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import {
    Table,
} from 'appkit-react';

import Loader from 'views/Shared/components/Loader';
import { GetFileData } from '../containers/DataPreviewTab';

const DataPreviewTab = ({
    selectedNode, showColumnsModal, setShowColumnsModal,
    projectId,
}) => {
    const { id: nodeId, type: selectedType, data: { label = '', fileName = '' } = {} } = selectedNode;
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [data, setData] = useState([]);

    /* function to fetch file data based on selected file */
    const { fileData, isFileDataLoading } = GetFileData(fileName, projectId, nodeId);

    /* side effect when file data is changed */
    useEffect(() => {
        if (fileData && fileData.length > 0) {
            const columns = [];
            const configData = Object.keys(fileData[0]);
            configData.forEach(c => {
                columns.push({
                    accessor: c,
                    Header: c,
                    resizable: true,
                    minWidth: 70,
                });
            });
            setSelectedColumns(columns);
            setData(fileData);
        }
    }, [fileData]);

    /* callback function called when Show Columns button is clicked */
    const handleClick = () => {
        setShowColumnsModal(!showColumnsModal);
    };
    if (isFileDataLoading) {
        return <Loader />;
    }
    if (Object.keys(selectedNode).length && label && selectedType === 'input') {
        const isTableDataAvailable = selectedColumns && selectedColumns.length > 0 && data && data.length > 0;
        return (
            <>
                <div className="true-comply-datarecon__tabs-tabtwo-header">
                    <p>{`File Name : ${label}`}</p>
                    <div className="true-comply-datarecon__tabs-tabtwo-header__icons-section">
                        <span className="appkiticon icon-pencil-fill" onClick={handleClick} role="presentation" />
                        <span className="appkiticon icon-transform-outline" />
                        <span className="appkiticon icon-delete-fill" />
                    </div>
                </div>
                { isTableDataAvailable && (
                    <div className="true-comply-datarecon__tabs-tabtwo-body marginTop20">
                        <Table
                            data={data}
                            columns={selectedColumns}
                            defaultPageSize={10}
                            resizable
                            sortable={false}
                        />
                    </div>
                )}
            </>
        );
    }
    return <div> No Data Found!</div>;
};

export default DataPreviewTab;
